import Vue from 'vue';

export class BWS {
    static sendIp(json){
        return Vue.http.post('configuracao-bws/ip', json);
    }

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('configuracao-bws/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }
}
